import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import withRouter from '../../../components/withRouter';
import TableContainer from '../../../components/TableContainerReactTable';
import AddEditAdvertiserModal from '../components/advertiser/AddEditAdvertiserModal';
import { getAdvertisers } from '../services/advertiserApi';
import { Advertiser } from '../types/advertiser';
import { cnpjMask } from '../../../utils';
import { Loader2 } from 'lucide-react';

const Index = (props: any) => {
    const [data, setData] = useState<Advertiser[]>([]);
    const [dataToEdit, setDataToEdit] = useState<Advertiser | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [isAddModalOpen, setIsAddModalOpen] = useState<boolean>(false);

    useEffect(() => {
        getAdvertisers().then((res) => {
            setData(res);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    const toggleAddModal = () => {
        setIsAddModalOpen(!isAddModalOpen);
    };

    const handleUpdateData = (newData: Advertiser) => {
        const updatedData = data.map((item) => {
            if (item.id === newData.id) {
                return newData;
            }
            return item;
        });
        setData(updatedData);
    };

    const handleAddData = (newData: Advertiser) => {
        setData([...data, newData]);
    };

    const dateFormatOptions: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZoneName: 'shortOffset',
    };

    const columns = [
        {
            header: '#',
            cell: (cell: any) => {
                return (
                    <span className="fw-semibold">{cell.getValue()}</span>
                );
            },
            accessorKey: 'id',
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Nome',
            accessorKey: 'name',
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'CNPJ',
            accessorFn: (row: any) => {
                return row.cnpj ? cnpjMask(row.cnpj) : '-';
            },
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Campanhas',
            accessorKey: 'campaigns.length',
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Usuários',
            accessorKey: 'users.length',
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Criado em',
            accessorFn: (row: any) => {
                const date = new Date(row.createdAt);
                return date.toLocaleDateString('pt-BR', dateFormatOptions);
            },
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Atualizado em',
            accessorFn: (row: any) => {
                const date = new Date(row.updatedAt);
                return date.toLocaleDateString('pt-BR', dateFormatOptions);
            },
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Actions',
            cell: (_cell: any) => {
                return null;
            },
            enableColumnFilter: false,
        },
    ];

    document.title = 'Anunciantes | Ad Pulse';
    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="grid gap-4">
                        <Card>
                            <CardHeader>
                                <div className="flex items-center justify-between">
                                    <div className="flex-1">
                                        <CardTitle>Anunciantes</CardTitle>
                                    </div>
                                    <div>
                                        <Button
                                            onClick={() => {
                                                setDataToEdit(null);
                                                toggleAddModal();
                                            }}
                                            className="bg-green-600 hover:bg-green-700"
                                        >
                                            <i className="ri-add-line align-bottom mr-1"></i> Adicionar advertiser
                                        </Button>
                                    </div>
                                </div>
                            </CardHeader>
                            <CardContent>
                                {!loading ? (
                                    <TableContainer
                                        divClass="table-responsive"
                                        columns={(columns || [])}
                                        data={(data || [])}
                                        isGlobalFilter={true}
                                        customPageSize={30}
                                        SearchPlaceholder="Procurar..."
                                    />
                                ) : (
                                    <div className="flex justify-center">
                                        <Loader2 className="h-8 w-8 animate-spin text-primary" />
                                    </div>
                                )}

                                <AddEditAdvertiserModal
                                    advertiser={dataToEdit}
                                    isOpen={isAddModalOpen}
                                    toggle={toggleAddModal}
                                    onAddData={handleAddData}
                                    onUpdateData={handleUpdateData}
                                />
                            </CardContent>
                        </Card>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default withRouter(Index);
